/* unplugin-vue-components disabled */import { render } from "./ExternalContacts.vue?vue&type=template&id=41844f90&scoped=true&ts=true"
import script from "./ExternalContacts.vue?vue&type=script&lang=ts"
export * from "./ExternalContacts.vue?vue&type=script&lang=ts"

import "./ExternalContacts.vue?vue&type=style&index=0&id=41844f90&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41844f90"]])

export default __exports__